import { Resource } from "../resource/resource.model";

export class ContactPreferenceHistory extends Resource {
    emailAddress: string;
    masterPreferenceId: string;
    value: string;
    formId: string;
    pageId: string;
    tenantId: string;
    dateCreated: Date;
    channels: string;
    frequencies: string;
    source: string;
}
